import axiosInstance from './axiosInstance';

const getApiUrl = () => process.env.REACT_APP_API_URL;

export const getPagePrivileges = async () => {
  const response = await axiosInstance.get(`${getApiUrl()}/page-privileges`);
  return response.data;
};

export const getRolePagePrivilegesByRoleId = async (roleId) => {
  const response = await axiosInstance.get(`${getApiUrl()}/role-page-privileges/by-role/${roleId}`);
  return response.data;
};

export const updateRolePagePrivileges = async (roleId, pageIds) => {
  const response = await axiosInstance.put(`${getApiUrl()}/role-page-privileges/bulk/${roleId}`, {
    pagePrivilegeIds: pageIds,
  });
  return response.data;
};
